import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BoxFullPage = styled(Box)(() => ({
  '&.MuiBox-root': {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    top: '0px',
    left: '0px',
    color: 'var(--body_color)',
    backgroundColor: 'var(--body_background)',
    overflow: 'scroll',
  },
}));

export const BoxClosePlacement = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  maxWidth: '600px',
  margin: '0 auto -20px auto',
  padding: '10px 10px 0 0',
}));
